<template>
    <div class="container feedback template-bg-gray my-position-relative">
        <md-card class="request-status loop_container bg-transparent update-request-form-common">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-if="!message.length">checking...</h4>
                    <h4 class="template-custom-title" else>{{message}}</h4>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import API from "../services/API";
export default {
    name: 'RequestStatus',
    props: ['communityId', 'ask_id', 'action', 'status', 'adminId'],
    data() {
        return {
            fullPage: true,
            api: new API(),
            message: ''
        }
    },
    beforeCreate() {
        if (!this.$route.query.askid || !this.$route.query.action || !this.$route.query.status || !this.$route.query.adminId) {
            this.$router.push('/');
        }
    },
    async created() {
        localStorage.setItem('community_id', this.communityId);
        await this.$nextTick(); // Ensure localStorage is committed before API calls
        await this.api.get(`asks/${this.ask_id}`).then(async ask => {
            if (ask.data.status && ask.data._id && ask.data.status !== '(8) Rejected' && ask.data.status === 'In Review') {
                await this.api.post(`asks/check-status`, {askId: this.ask_id, action: this.action, status: this.status, adminId: this.adminId}).then(response => {
                    if (response.data.status === '(8) Rejected') {
                        let adminEvent = '';
                        if (this.status === 'coach') {
                            adminEvent = 'AdminRejectAndCoach';
                        } else if (this.status === 'no') {
                            adminEvent = 'AdminRejectAndDelete';
                        }
                        this.$gtm.enable(true)
                        this.$gtm.trackEvent({
                            'RequestID': ask.data._id,
                            'RequestSource': 'Web',
                            'RequestReceived': this.$moment(ask.data.createdAt).tz("America/New_York").format('YYYYMMDD'),
                            'Community': ask.data.community.name,
                            'AdminID': this.adminId,
                            'event': adminEvent
                        });
                        this.message = 'Thank you for your response';
                    } else if (response.data.status === 'Reviewed' && this.status === 'no') {
                        this.$gtm.enable(true)
                        this.$gtm.trackEvent({
                            'RequestID': ask.data._id,
                            'RequestSource': 'Web',
                            'RequestReceived': this.$moment(ask.data.createdAt).tz("America/New_York").format('YYYYMMDD'),
                            'Community': ask.data.community.name,
                            'AdminID': this.adminId,
                            'event': 'AdminApproveAndContinueReview'
                        });
                        this.message = 'Thank you for approving the request.';
                    } else if (response.data.status === 'Reviewed' && this.status === 'yes') {
                        this.$gtm.enable(true)
                        this.$gtm.trackEvent({
                            'RequestID': ask.data._id,
                            'RequestSource': 'Web',
                            'RequestReceived': this.$moment(ask.data.createdAt).tz("America/New_York").format('YYYYMMDD'),
                            'Community': ask.data.community.name,
                            'AdminID': this.adminId,
                            'event': 'AdminApproveAllFuture'
                        });
                        this.message = 'Thank you for approving the request.';
                    } else {
                        this.message = 'Thank you';
                    }
                });
            } else {
                this.message = 'Thank you';
            }
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/RequestStatus.vue